/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Map_MetaInputs */

const en_us2_progress_extra_map_meta = /** @type {(inputs: Progress_Extra_Map_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sets this week`)
};

const pt_br2_progress_extra_map_meta = /** @type {(inputs: Progress_Extra_Map_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries na semana`)
};

const es_419_progress_extra_map_meta = /** @type {(inputs: Progress_Extra_Map_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`series esta semana`)
};

const pt_pt2_progress_extra_map_meta = /** @type {(inputs: Progress_Extra_Map_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries na semana`)
};

const fr_fr2_progress_extra_map_meta = /** @type {(inputs: Progress_Extra_Map_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries cette semaine`)
};

const de_de2_progress_extra_map_meta = /** @type {(inputs: Progress_Extra_Map_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze diese Woche`)
};

const it_it2_progress_extra_map_meta = /** @type {(inputs: Progress_Extra_Map_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`serie questa settimana`)
};

/**
* | output |
* | --- |
* | "sets this week" |
*
* @param {Progress_Extra_Map_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_meta = /** @type {((inputs?: Progress_Extra_Map_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_meta(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_meta(inputs)
	return en_us2_progress_extra_map_meta(inputs)
});
export { progress_extra_map_meta as "progress-extra.map_meta" }